import React from 'react';

const MembershipCashPlanFormModal = React.lazy(() => import('../components/FormModal'));
const membershipCashPlanModalRegistry = {
    core_membershipCashPlanId: MembershipCashPlanFormModal
};
export default membershipCashPlanModalRegistry;
